import AdminListPage from "./components/AdminListPage";
export default function NamaList() {
	return (
		<AdminListPage
			title="Senarai Nama"
			endpoint="/admin/nama"
		/>
	);
}
